import { useState, useEffect } from "react";

// Helper function to map point data to form data (can be kept here or moved to utils)
const mapPointToFormData = (pointToEdit) => {
  if (!pointToEdit) return null;

  return {
    id: pointToEdit.id,
    pointName: pointToEdit.title, // Map from 'title'
    pointType: pointToEdit.type, // Map from 'type'
    supportType: pointToEdit.support_type, // Map from 'support_type'
    installationType: pointToEdit.connection_type, // Map from 'connection_type'
    powerSupplyType: pointToEdit.power_type, // Map from 'power_type'
    comment: pointToEdit.comment || "",
    hasCameras: pointToEdit.has_camera ? "yes" : "no", // Map from 'has_camera'
    photos: (pointToEdit.localisations || []).map((loc, i) => ({
      id: loc.id, // Keep the original location ID
      url: loc.full_path || "", // Use image_url for display
      name: `Location_${i + 1}.jpg`, // Create a placeholder name
      location: `${loc.latitude || "N/A"}, ${loc.longitude || "N/A"}`,
      latitude: loc.latitude,
      longitude: loc.longitude,
      isNew: false, // Mark these as existing
    })),
    cameras: pointToEdit.cameras || [], // Map cameras directly
    recorderSize: pointToEdit.recorder_size,
    screenSize: pointToEdit.screen_size,
    coverageArea: pointToEdit.coverage_area,
  };
};

export const useEditPointForm = (pointToEdit, navigate) => {
  const [formData, setFormData] = useState(null);
  const [initialCameraIds, setInitialCameraIds] = useState([]);

  useEffect(() => {
    if (!pointToEdit) {
      console.error("Aucune donnée de point fournie pour modification");
      if (navigate) navigate(-1); // Use navigate if provided
      return;
    }

    const mappedData = mapPointToFormData(pointToEdit);
    setFormData(mappedData);
    setInitialCameraIds((pointToEdit.cameras || []).map((c) => c.id));
  }, [pointToEdit, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return {
    formData,
    setFormData, // Expose setFormData if needed for direct updates (like photo handling)
    initialCameraIds,
    setInitialCameraIds, // Expose if needed
    handleChange,
  };
};
